import { render, staticRenderFns } from "./ProductTag.vue?vue&type=template&id=50ddacdb&"
import script from "./ProductTag.vue?vue&type=script&lang=js&"
export * from "./ProductTag.vue?vue&type=script&lang=js&"
import style0 from "./ProductTag.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50ddacdb')) {
      api.createRecord('50ddacdb', component.options)
    } else {
      api.reload('50ddacdb', component.options)
    }
    module.hot.accept("./ProductTag.vue?vue&type=template&id=50ddacdb&", function () {
      api.rerender('50ddacdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductTag.vue"
export default component.exports